import * as S from "./styled";

const { Avatar } = S;

export default Avatar;
